import { commentsData } from '@/mocks/home-data';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3 justify-center">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            吃瓜群众说
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 text-center">
          来自真实用户的评价与反馈
        </p>

        <div className="space-y-4">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-lg p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-heading text-primary-600">
                    {comment.avatar}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-800">
                      {comment.user}
                    </span>
                    <span className="text-xs text-foreground-400">
                      {comment.time}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}